import React from 'react';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { getInitials } from '@/utils/utility';
import { RoleTag, ROLE_AVATAR_STYLE_MAP } from './RoleTag.component';
import styles from './EmployeeAvatarHeader.module.scss';

/**
 * Avatar + name + role pill row shared by the "Employee details" and
 * "Edit Employee Details" dialogs, rendered as the PrimeReact Dialog's
 * `header` so it shares a row with the dialog's close icon.
 *
 * `meta` replaces the default role pill with a secondary text line below
 * the name (e.g. "Admin • Development") — used where this is shown as
 * in-body context (e.g. "Change active team") rather than the dialog title.
 */
export const EmployeeAvatarHeader = ({ name, role, meta }) => (
  <div className={styles.employeeAvatarHeader}>
    <span className={styles.avatar} style={ROLE_AVATAR_STYLE_MAP[role]}>
      {getInitials(name || '')}
    </span>
    <div className={styles.headerText}>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Semibold}
      >
        {name}
      </Text>
      {meta ? (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Normal}
          color="gray-600"
        >
          {meta}
        </Text>
      ) : (
        <RoleTag role={role} />
      )}
    </div>
  </div>
);
